/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import MaterialProperty from './MaterialProperty';

/**
 * The NftControllerDtoNftGenerateDetailResponse model module.
 * @module model/NftControllerDtoNftGenerateDetailResponse
 * @version 1.0
 */
class NftControllerDtoNftGenerateDetailResponse {
    /**
     * Constructs a new <code>NftControllerDtoNftGenerateDetailResponse</code>.
     * @alias module:model/NftControllerDtoNftGenerateDetailResponse
     */
    constructor() { 
        
        NftControllerDtoNftGenerateDetailResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftControllerDtoNftGenerateDetailResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftControllerDtoNftGenerateDetailResponse} obj Optional instance to populate.
     * @return {module:model/NftControllerDtoNftGenerateDetailResponse} The populated <code>NftControllerDtoNftGenerateDetailResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftControllerDtoNftGenerateDetailResponse();

            if (data.hasOwnProperty('resultCode')) {
                obj['resultCode'] = ApiClient.convertToType(data['resultCode'], 'Number');
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('errorCode')) {
                obj['errorCode'] = ApiClient.convertToType(data['errorCode'], 'Number');
            }
            if (data.hasOwnProperty('contentsReward')) {
                obj['contentsReward'] = ApiClient.convertToType(data['contentsReward'], [MaterialProperty]);
            }
            if (data.hasOwnProperty('generateNo')) {
                obj['generateNo'] = ApiClient.convertToType(data['generateNo'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
            if (data.hasOwnProperty('nftCount')) {
                obj['nftCount'] = ApiClient.convertToType(data['nftCount'], 'Number');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('nftSeal')) {
                obj['nftSeal'] = ApiClient.convertToType(data['nftSeal'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftControllerDtoNftGenerateDetailResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftControllerDtoNftGenerateDetailResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['contentsReward']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['contentsReward'])) {
                throw new Error("Expected the field `contentsReward` to be an array in the JSON data but got " + data['contentsReward']);
            }
            // validate the optional field `contentsReward` (array)
            for (const item of data['contentsReward']) {
                MaterialProperty.validateJSON(item);
            };
        }
        // ensure the json data is a string
        if (data['title'] && !(typeof data['title'] === 'string' || data['title'] instanceof String)) {
            throw new Error("Expected the field `title` to be a primitive type in the JSON string but got " + data['title']);
        }

        return true;
    }


}



/**
 * @member {Number} resultCode
 */
NftControllerDtoNftGenerateDetailResponse.prototype['resultCode'] = undefined;

/**
 * @member {String} code
 */
NftControllerDtoNftGenerateDetailResponse.prototype['code'] = undefined;

/**
 * @member {String} description
 */
NftControllerDtoNftGenerateDetailResponse.prototype['description'] = undefined;

/**
 * @member {Number} errorCode
 */
NftControllerDtoNftGenerateDetailResponse.prototype['errorCode'] = undefined;

/**
 * @member {Array.<module:model/MaterialProperty>} contentsReward
 */
NftControllerDtoNftGenerateDetailResponse.prototype['contentsReward'] = undefined;

/**
 * @member {Number} generateNo
 */
NftControllerDtoNftGenerateDetailResponse.prototype['generateNo'] = undefined;

/**
 * @member {String} title
 */
NftControllerDtoNftGenerateDetailResponse.prototype['title'] = undefined;

/**
 * @member {Number} nftCount
 */
NftControllerDtoNftGenerateDetailResponse.prototype['nftCount'] = undefined;

/**
 * @member {Number} status
 */
NftControllerDtoNftGenerateDetailResponse.prototype['status'] = undefined;

/**
 * @member {Number} nftSeal
 */
NftControllerDtoNftGenerateDetailResponse.prototype['nftSeal'] = undefined;

/**
 * @member {Date} createdAt
 */
NftControllerDtoNftGenerateDetailResponse.prototype['createdAt'] = undefined;






export default NftControllerDtoNftGenerateDetailResponse;

